import { CanvasElementType, CanvasLayer, CanvasObjectPosition, CanvasObjectSize } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

export const defaultFrameSize: CanvasObjectSize = {
  width: 1200,
  height: 800,
};

export function getCanvasFrameModel(data: { position: CanvasObjectPosition; size: CanvasObjectSize }) {
  return {
    type: CanvasElementType.Frame,
    size: data.size,
    styles: defaultCanvasGenericStyles,
    position: data.position,
    layer: CanvasLayer.Frames,
    typeSettings: {},
    objectProperties: {
      ...defaultCanvasObjectProperties,
      rotatable: false,
    },
  };
}

export type CanvasFrameModel = VisualizationCanvasElementStoreModel<CanvasElementType.Frame>;
